import env from 'env'
import { zonedTimeToUtc } from 'date-fns-tz'
import config from 'app/config'

export function getOrderUrl(stallId, event) {
  let url = `${env.SLEEK_ORDER_URL}/stall/${stallId}`

  if (event) {
    let startTime = event.start_date
    let endTime = event.end_date

    if (event.address && event.address.timezone) {
      startTime = zonedTimeToUtc(startTime, event.address.timezone)
      endTime = zonedTimeToUtc(endTime, event.address.timezone)
    }

    const state = {
      startTime: startTime.getTime(),
      endTime: endTime.getTime(),
    }

    if (event.address?.location) {
      state.gpsLocation = [
        event.address.location?.lat,
        event.address.location?.lng,
      ]
    }

    url = `${url}?rh_state=${base64Encode(JSON.stringify(state))}`
  }

  return url
}

function base64Encode(str) {
  if (typeof window === 'undefined') {
    return Buffer.from(str).toString('base64')
  } else {
    return btoa(str)
  }
}

export function isOADisabled(caterer_id) {
  return config.disabled_oa_caterers.indexOf(Number(caterer_id)) >= 0
}
